(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rk-currency-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rk-currency-selector')) {
    customElements.define(
      'rk-currency-selector',
      class RkCurrencySelector extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector('.rk-cc__trigger');
          this.list = this.querySelector('.rk-cc__list');
          this.options = [...this.querySelectorAll('.rk-cc__option')];
          this.trigger.addEventListener('click', () => (this.isOpen() ? this.close() : this.open()));
          this.addEventListener('keydown', (e) => this.onKey(e));
          this.addEventListener('focusout', (e) => {
            if (this.isOpen() && e.relatedTarget && !this.contains(e.relatedTarget)) this.close();
          });
          this.list.addEventListener('click', (e) => {
            const opt = e.target.closest('.rk-cc__option');
            if (opt && opt.getAttribute('aria-current') === 'true') {
              e.preventDefault();
              this.close(true);
            }
          });
          this.onOutside = (e) => {
            if (!this.contains(e.target)) this.close();
          };
          this.onResize = () => this.close();
        }

        isOpen() {
          return this.trigger.getAttribute('aria-expanded') === 'true';
        }

        open() {
          if (window.matchMedia('(max-width: 768px)').matches) {
            const box = this.getBoundingClientRect();
            const vw = document.documentElement.clientWidth;
            this.style.setProperty('--rk-cc-left', `${16 - box.left}px`);
            this.style.setProperty('--rk-cc-width', `${vw - 32}px`);
            this.style.setProperty('--rk-cc-max', `${window.innerHeight - box.bottom - 20}px`);
          }
          this.list.hidden = false;
          this.trigger.setAttribute('aria-expanded', 'true');
          this.list.scrollTop = 0;
          document.addEventListener('click', this.onOutside);
          window.addEventListener('resize', this.onResize);
          window.addEventListener('scroll', this.onResize, { passive: true });
        }

        close(focusTrigger = false) {
          this.list.hidden = true;
          this.trigger.setAttribute('aria-expanded', 'false');
          document.removeEventListener('click', this.onOutside);
          window.removeEventListener('resize', this.onResize);
          window.removeEventListener('scroll', this.onResize);
          if (focusTrigger) this.trigger.focus();
        }

        onKey(e) {
          if (e.key === 'Escape' && this.isOpen()) {
            e.preventDefault();
            this.close(true);
            return;
          }
          if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
          e.preventDefault();
          if (!this.isOpen()) this.open();
          const i = this.options.indexOf(document.activeElement);
          const step = e.key === 'ArrowDown' ? 1 : -1;
          const next = i === -1 ? (step === 1 ? 0 : this.options.length - 1) : (i + step + this.options.length) % this.options.length;
          this.options[next].focus();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
